// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"eed4f104","849":"e726fb93","977":"c0133861"}[chunkId] + ".chunk.js";
};